import i18n from '../../i18n';

export class Text {
  static get title(): string {
    return i18n._translate('The latest from iFIT', {
      context: 'A heading above a row of cards telling the user about current news and notifications.',
    });
  }
}
